import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

interface SegmentModalState {
  isLoading: boolean;
}

const initialState: SegmentModalState = {
  isLoading: false
};

export const SegmentModalStore = signalStore(
  withState(initialState),
  withMethods((store) => ({
    updateIsLoading: (isLoading: boolean) => {
      patchState(store, { isLoading });
    }
  }))
);
